import "./OurServices.module.css";
import Header from "@/reusable_sections/Header";
import OurPhilosophy from "./sections/OurPhilosophy";
import MainServices from "./sections/MainServices";
import GeorgiaGallery from "./sections/GeorgiaGallery";
import Footer from "@/reusable_sections/Footer";
export default function OurServicesPage() {
  return <div>
      <Header />
      <OurPhilosophy />
      <MainServices />
      <GeorgiaGallery />
      <Footer />
    </div>;
}